import { render, staticRenderFns } from "./Supporters.vue?vue&type=template&id=31e607a8&scoped=true&"
import script from "./Supporters.vue?vue&type=script&lang=ts&"
export * from "./Supporters.vue?vue&type=script&lang=ts&"
import style0 from "./Supporters.vue?vue&type=style&index=0&id=31e607a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e607a8",
  null
  
)

/* custom blocks */
import block0 from "./Supporters.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports